export default "__VITE_ASSET__BCtKN8nX__"